module.exports = __webpack_public_path__ + "media/12_34.ddd5ccc7.wav";